import React, { useState, useEffect } from 'react';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1.jsx";
import Table1 from './Table1.jsx';
import Table2 from './Table2.jsx';
import Table3 from './Table3.jsx';
import { useGetPurchaseOrderListMutation } from '../../../../store/api/gateEntryApiNew'
import Tab2 from './Tab2.jsx';
import { useGetGenderOptionsQuery, useGetUserOptionsQuery, useGetSalutationOptionsQuery, useGetDocTypeOptionsQuery, useCreateContactMutation } from '../../../../store/api/contactapi.jsx'
import { useNavigate } from 'react-router-dom';
import { usePageState } from '../../../../Hook/usePageState.jsx';
function Contact() {
    const [createContact, { isLoadingsix, errorsix, data }] = useCreateContactMutation();
    const navigate = useNavigate();

    const [tab, settab] = useState(1);
    const [res, setRes] = useState(false);
    const [error, setError] = useState('');
    const [errors, setErrors] = useState({});
    const [ptype, setptype] = useState("Error");
    const [showError, setShowError] = useState(false);
    const [selected_item_data, setselected_item_data] = useState([]);
    const [selected_item_data_two, setselected_item_data_two] = useState([]);
    const [selected_item_data_three, setselected_item_data_three] = useState([]);
    const [getitem_list_data] = useGetPurchaseOrderListMutation();
    const [genderList, setGenderList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [salutationList, setsalutationList] = useState([]);
    const [doctypeList, setdoctypeList] = useState([]);
    const { data: genders, isLoading, errortwo } = useGetGenderOptionsQuery();
    const { data: users, isLoadingthrre, errorthree } = useGetUserOptionsQuery();
    const { data: salutation, isLoadingfour, errorfour } = useGetSalutationOptionsQuery();
    const { data: doctype, isLoading: isLoadingfive, error: errorfive, refetch } = useGetDocTypeOptionsQuery();
    useEffect(() => {
        if (genders) {
            setGenderList(genders.data)
        }
        if (users) {

            setUserList(users.data)
        }
        if (salutation) {

            setsalutationList(salutation.data)
        }
        if (doctype) {

            setdoctypeList(doctype.data)
        }
    }, [genders, users, salutation]);
    const [formData, setFormData] = useState({
        solution: '',
        firstname: '',
        lastname: '',
        gender: '',
        userid: '',
        address: '',
        designation: '',
        company_name: '',
        status: '',
        is_google: false,
        unsubscribed: false,
        department: '',
        is_primary_contact: false,
        is_billing_contact: false

    });


    const pageStateDefault = {
        tab: 1,
        solution: "",
        firstname: "",
        lastname: "",
        gender: "",
        userid: "",
        address: "",
        designation: "",
        company_name: "",
        status: "",
        department: "",
        is_google: true,
        unsubscribed: false,
        is_primary_contact: true,
        is_billing_contact: false,

    }
    const [pageState, setPageState] = usePageState(`Create Contact`, pageStateDefault);
    console.log(pageState,"pageState values");
    
    const handleInputChange1 = (f, v) => {
        setPageState({ ...pageState, [f]: v });

    };
    const validateForm = () => {
        const newErrors = {};

        // Tab1 validations
        if (!pageState.solution) newErrors.solution = "Salutation is required";
        if (!pageState.firstname) newErrors.firstname = "First name is required";
        if (!pageState.lastname) newErrors.lastname = "Last name is required";
        if (!pageState.gender) newErrors.gender = "Gender is required";
        if (!pageState.userid) {
            newErrors.userid = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(pageState.userid)) {
            newErrors.userid = "Invalid email format";
        }
        if (!pageState.address) newErrors.address = "Address is required";
        if (!pageState.designation) newErrors.designation = "Designation is required";
        if (!pageState.company_name) newErrors.company_name = "Company name is required";
        if (!pageState.status) newErrors.status = "Status is required";

        // Tab2 validations
        if (!pageState.department) newErrors.department = "Department is required";

        setErrors(newErrors);

        // return false if errors exist
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            // show first error in alert
            const firstErrorKey = Object.keys(errors)[0];
            const firstErrorMsg = errors[firstErrorKey];
            setError(firstErrorMsg || "")
            setptype('Error');
            setShowError(true);
            return;
        }

        const payload = {
            first_name: pageState.firstname,
            last_name: pageState.lastname,
            email_id: pageState.userid,
            status: pageState.status,
            salutation: pageState.solution,
            designation: pageState.designation,
            gender: pageState.gender,
            mobile_no: selected_item_data_two?.find(e => e.is_primary_mobile)?.number || "",
            company_name: pageState.company_name,
            is_primary_contact: pageState.is_primary_contact ? 1 : 0,
            is_billing_contact: pageState.is_billing_contact ? 1 : 0,
            department: pageState.department,
            unsubscribed: pageState.unsubscribed ? 1 : 0,
            email_ids: selected_item_data.map(e => ({
                email_id: e.email,
                is_primary: e.is_primary ? 1 : 0
            })),
            phone_nos: selected_item_data_two.map(e => ({
                phone: e.number,
                is_primary_phone: e.is_primary_phone ? 1 : 0,
                is_primary_mobile_no: e.is_primary_mobile ? 1 : 0
            })),
            links: selected_item_data_three.map(e => ({
                link_doctype: e.Link_Document_Type,
                link_name: e.Link_Name
            }))
        };

        try {
            const response = await createContact(payload).unwrap();
            console.log("Contact Created:", response);
            setPageState(pageStateDefault);
            setError('Contact created successfully!');
            setptype('Success');
            setShowError(true);
            setTimeout(() => {
                navigate('/master/contact-list');
            }, 1500);
        } catch (err) {
            console.error("Creation Failed:", err);
            setError('Failed to create contact.');
            setptype('Error');
            setShowError(true);
        }
    };

    return (
        <>
            <FormLayoutTwo
                title="Create Contact"
                breadcrumbs={[
                    { label: "Master" },
                    { label: "Contact ", url: '/master/contact-list' }
                ]}
                status={res ? 'Draft' : 'New'}
                actionButtons={
                    <>
                        <Button
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            onClick={handleSubmit}
                            iconSize={12}
                        >
                            Save
                        </Button>

                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                    <a className={tab === 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => settab(1)} href="javascript:void(0);">
                                        General Details {tab === 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                            <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                                <span style={{ position: "relative", top: "-1px" }}>
                                    <GetIcon className="text-[#4B002B]" iconName="CgAttachment" size={12} />
                                </span>
                                <span className="fw-semibold" style={{ color: "#4B002B" }}>
                                    Attachments
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className=" " style={{ background: '' }}>
                        <div className="row">
                            <div className="col-12">
                                <div className="sidebarbox m-0">
                                    <Tab1
                                        salutationList={salutationList}
                                        genderList={genderList}
                                        userList={userList}
                                        pageState={pageState}
                                        handleChange={handleInputChange1}
                                        errors={errors}
                                        doctypeList={doctypeList}
                                        refetch={refetch}
                                        list_data={getitem_list_data}
                                        setselected_item_data={setselected_item_data}
                                        setselected_item_data_two={setselected_item_data_two}
                                        setselected_item_data_three={setselected_item_data_three}
                                        onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}

                                    />
                                </div>
                                {/* <div className="sidebarbox m-0">
                                    <Table1
                                        setselected_item_data={setselected_item_data}

                                    />
                                </div>
                                <div className="sidebarbox m-0">
                                    <Table2
                                        setselected_item_data={setselected_item_data_two}

                                    />
                                </div>

                                <div className="sidebarbox m-0">
                                    <Table3
                                        doctypeList={doctypeList}
                                        refetch={refetch}
                                        list_data={getitem_list_data}

                                        setselected_item_data={setselected_item_data_three}
                                        formData={formData}
                                        onInputChange={handleInputChange}

                                    />
                                </div> */}


                                {/* <div className="sidebarbox m-0">
                                    <Tab2
                                        errors={errors}


                                        formData={formData}
                                        onInputChange={handleInputChange}
                                    />
                                </div> */}
                            </div>
                        </div>
                    </div>

                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayoutTwo>
        </>
    );
}

export default Contact;
